import { Card, CardContent, Grid, Typography } from "@material-ui/core";
import type { ModalWorkOrder } from "@/shared/work-orders-modals/models/ModalWorkOrder";
import type { WorkOrder } from "@/pages/work-orders/models/WorkOrder";
import { dxtToLocalServerTime } from "@dexteel/mesf-core";

export const WorkOrderCard = ({
	workOrder,
}: {
	workOrder: ModalWorkOrder | WorkOrder;
}) => {
	return (
		<Card variant="outlined" style={{ margin: "10px 0" }}>
			<CardContent style={{ paddingTop: 12, paddingBottom: 12 }}>
				<Grid container spacing={1}>
					<Grid item xs={12}>
						<Typography variant="h6">
							{workOrder.WorkOrderName} - {workOrder.Title}
						</Typography>
					</Grid>
					<Grid item xs={6}>
						<Typography variant="body2">
							Asset: {workOrder.AssetName}
						</Typography>
					</Grid>
					<Grid item xs={6}>
						<Typography variant="body2">
							Opened by: {workOrder.WorkOrderOpenedBy}
						</Typography>
					</Grid>
					<Grid item xs={6}>
						<Typography variant="body2">
							Status: {workOrder.WorkOrderStatusCode}
						</Typography>
					</Grid>
					<Grid item xs={6}>
						<Typography variant="body2">
							Opened:{" "}
							{workOrder.OpenTimestamp
								? (workOrder.OpenTimestamp as Date)
									? dxtToLocalServerTime(
											workOrder.OpenTimestamp,
											"MM/dd/yy HH:mm",
										)
									: workOrder.OpenTimestamp
								: "N/A"}
						</Typography>
					</Grid>
				</Grid>
			</CardContent>
		</Card>
	);
};
